import React from 'react';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import moment, { utc } from 'moment';
// eslint-disable-next-line no-unused-vars
import fr from 'moment/locale/fr';

import InnerLink from './InnerLink';

// eslint-disable-next-line no-unused-vars
const EventsBlock = ({ strings, loading, contract, i18n }) => {
  const { events } = contract;

  const formatDate = ({ date }) => {
    if (typeof date === 'undefined') return undefined;
    const { compactDateFormat, lang } = i18n;
    moment.locale(lang || 'en');
    return utc(date).format(compactDateFormat);
  };

  const formatHour = ({ date }) => {
    if (typeof date === 'undefined') return undefined;
    const { hourFormat, lang } = i18n;
    moment.locale(lang || 'en');
    return utc(date).format(hourFormat);
  };

  const getDate = event => {
    try {
      const date = formatDate({ date: event.date });
      return date;
    } catch (error) {
      return '';
    }
  };

  const getHour = event => {
    try {
      return formatHour({ date: event.date });
    } catch (error) {
      return '';
    }
  };

  const getContract = () => {
    try {
      const { id, contract_number, quote_number } = contract;
      const contractId = contract_number || quote_number || id;
      return <InnerLink route={`/contracts/${id}`} label={contractId} value={id} />;
    } catch (error) {
      return '';
    }
  };

  const getName = event => {
    try {
      return event.event_type.rec_name;
    } catch (error) {
      return '';
    }
  };

  const getDescription = event => {
    try {
      return event.description_str;
    } catch (error) {
      return '';
    }
  };

  return (
    // DATE DE L'ÉVÉNEMENT	HEURE DE L'ÉVÉNEMENT	NOM DE L'ÉVÉNEMENT	DESCRIPTION DE L'ÉVÉNEMENT
    <div className="events block">
      <Table className="table risk">
        <TableHead>
          <TableRow>
            <TableCell>{strings['contract.events.table.contractId.label'] || 'Numero de Contrat'}</TableCell>
            <TableCell>{strings['contract.events.table.date.label'] || 'Date'}</TableCell>
            <TableCell>{strings['contract.events.table.hour.label'] || 'Hour'}</TableCell>
            <TableCell>{strings['contract.events.table.name.label'] || 'Name'}</TableCell>
            <TableCell>{strings['contract.events.table.description.label'] || 'Description'}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {events && Array.isArray(events)
            ? events.map(row => (
                // eslint-disable-next-line react/jsx-indent
                <TableRow key={row.rec_name}>
                  <TableCell component="th" scope="row">
                    {getContract(row)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {getDate(row)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {getHour(row)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {getName(row)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {getDescription(row)}
                  </TableCell>
                </TableRow>
              ))
            : undefined}
        </TableBody>
      </Table>
    </div>
  );
};

EventsBlock.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  loading: PropTypes.objectOf(PropTypes.bool).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  contract: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
};

EventsBlock.defaultProps = {
  strings: {},
  i18n: {
    compactDateFormat: 'D MMM YYYY',
    dateFormat: 'D MMM YYYY',
    fullDateFormat: 'D MMM YYYY / HH:mm',
    hourFormat: 'HH:mm:ss',
    lang: 'fr',
  },
};
export default EventsBlock;
